import { Component, Input } from '@angular/core';
import { FolderDetail } from '../../folder.model';
import { SharedModule } from '@shared/shared.module';
import { MultipleProfileDisplayComponent } from '@shared/components/multiple-profile-display/multiple-profile-display.component';

@Component({
  selector: 'app-folder-share-with-display',
  standalone: true,
  templateUrl: './folder-share-with-display.component.html',
  styleUrls: ['./folder-share-with-display.component.scss'],
  imports: [SharedModule, MultipleProfileDisplayComponent],
})
export class FolderShareWithDisplayComponent {
  shareWithDisplayCount = 3;

  @Input() folder: FolderDetail;
  @Input() size = 24;
}
